import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PasswordGameCoreService } from '../password-game-core.service';
import { IPasswordGame } from '../password-game.interface';

@Component({
  selector: 'app-password-game-selector',
  templateUrl: './password-game-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PasswordGameSelectorComponent),
    },
  ],
})
export class PasswordGameSelectorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private _unsubscribe$ = new Subject<void>();

  @Input()
  hint = '';

  @Input()
  isEmptySelectable = false;

  @Output() itemSelected = new EventEmitter<IPasswordGame>();

  ctrl: FormControl = new FormControl();

  constructor(public passwordGameCoreService: PasswordGameCoreService) {}

  ngOnInit(): void {
    this.ctrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value: string) => {
        const passwordGame =
          this.passwordGameCoreService.getPasswordGameInfo(value);
        this.itemSelected.emit(passwordGame);
        this.onChange(value);
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch: any = (): void => {};

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  writeValue(v: string): void {
    this.ctrl.setValue(v);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  refresh(): void {
    this.passwordGameCoreService.refresh(true);
  }
}
